import React, { Component } from "react";
import { Layout, Icon } from "antd";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";

import LoginPage from "../pages/LoginPage";
// import CadastroPage from "../pages/CadastroPage";
import "./MainLayout.css";
import { getUsuario } from "../utils/LoginManager";
import SideMenu from "./SideMenu";
import './SideMenu.css';
import ContentRoutes from './ContentRoutes';

const { Header } = Layout;

export default class MainLayout extends Component {
  state = {};

  renderConteudo = () => {
    const usuario = getUsuario();
    return (
      <Layout className="mainLayout">
        <SideMenu />
  
        <Layout>
          <Header className="mainLayoutHeader">
            <Icon type="user" className="iconeLayout" />
            <h2>Olá {usuario.adm_usu_nome || usuario.adm_pes_nome}, bem vindo ao Siga Web 3</h2>
          </Header>

          <ContentRoutes />
        </Layout>

      </Layout>
    );
  };

  render() {
    return (
      <Switch>
        <Route path="/login" component={LoginPage} />
        {/* <Route path="/cadastro" component={CadastroPage} /> */}
        <PrivateRoute render={this.renderConteudo} />
        <div>Página não Encontrada</div>
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js